module.exports = __webpack_public_path__ + "static/media/权益一@2x.3f285b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益一@2x.png
// module id = 1136
// module chunks = 0